import { DateTime } from "luxon";
import type { ConversationServiceRequestData } from "./types.js";
import { Conversation } from "../Conversation/index.js";
import { DataModel } from "../../base/index.js";

export class ConversationServiceRequest extends DataModel<ConversationServiceRequestData> {
  public readonly conversation: Conversation;
  public readonly createdAt: DateTime;
  public readonly type: ConversationServiceRequestData["messageContent"];
  public readonly payload: ConversationServiceRequestData["meta"];
  public readonly articleType: string;
  public readonly days?: number;

  public constructor(data: ConversationServiceRequestData) {
    super(data);
    this.conversation = Conversation.ofId(data.conversationId);
    this.createdAt = DateTime.fromISO(data.createdAt);
    this.type = data.messageContent;
    this.payload = data.meta;
    this.articleType = data.meta.target.articleType;
    this.days =
      this.articleType === "cms-hosting"
        ? 10
        : this.articleType === "cms-hosting-express" ||
            this.articleType === "onlineshop-express"
          ? 3
          : this.articleType === "onlineshop"
            ? 14
            : undefined;
  }
}
